module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./QuickBuyView.js"));
	}, "QuickBuyForCouponView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuickBuyForCouponView!./src/pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyView.js
// module id = 1020
// module chunks = 438